"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
function useInterval(callback, delay) {
    var savedCallback = react_1.useRef();
    // Remember the latest callback.
    react_1.useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    react_1.useEffect(function () {
        function tick() {
            if (savedCallback.current)
                savedCallback.current();
        }
        if (delay !== null) {
            var id_1 = setInterval(tick, delay);
            return function () { return clearInterval(id_1); };
        }
    }, [delay]);
}
function calculateRemaining(diff) {
    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff - days * 86400000) / 3600000);
    var minutes = Math.floor((diff - days * 86400000 - hours * 3600000) / 60000);
    var seconds = Math.floor((diff - days * 86400000 - hours * 3600000 - minutes * 60000) / 1000);
    return { days: days, hours: hours, minutes: minutes, seconds: seconds };
}
var Countdown = function (_a) {
    var date = _a.date, containerClass = _a.containerClass, columnClass = _a.columnClass, timerClass = _a.timerClass, labelClass = _a.labelClass;
    var deadline = moment_1.default(date);
    var diff = deadline.diff(moment_1.default());
    var _b = react_1.useState(calculateRemaining(diff > 0 ? diff : 0)), time = _b[0], setTime = _b[1];
    var _c = react_1.useState(1000), delay = _c[0], setDelay = _c[1];
    react_1.useEffect(function () {
        setDelay(1000);
    }, [date]);
    useInterval(function () {
        if (diff <= 0) {
            setDelay(null);
            setTime(calculateRemaining(0));
        }
        else {
            setTime(calculateRemaining(diff));
        }
    }, delay);
    var days = time.days, hours = time.hours, minutes = time.minutes, seconds = time.seconds;
    return (react_1.default.createElement("div", { className: containerClass },
        react_1.default.createElement("div", { className: columnClass },
            react_1.default.createElement("div", { className: timerClass }, days),
            react_1.default.createElement("div", { className: labelClass }, "Days")),
        react_1.default.createElement("div", { className: columnClass },
            react_1.default.createElement("div", { className: timerClass }, hours < 10 ? "0" + hours : hours),
            react_1.default.createElement("div", { className: labelClass }, "Hours")),
        react_1.default.createElement("div", { className: columnClass },
            react_1.default.createElement("div", { className: timerClass }, minutes < 10 ? "0" + minutes : minutes),
            react_1.default.createElement("div", { className: labelClass }, "Minutes")),
        react_1.default.createElement("div", { className: columnClass },
            react_1.default.createElement("div", { className: timerClass }, seconds < 10 ? "0" + seconds : seconds),
            react_1.default.createElement("div", { className: labelClass }, "Seconds"))));
};
exports.default = Countdown;
//# sourceMappingURL=countdown.js.map